const url = {
  /**
   * Return a copy of route
   * @param route
   * @param asJson
   * @returns {*}
   */
  getRoute: function (route = {}, asJson = false) {
    let q = Object.assign({}, route.query || {})
    delete q.prevRoute
    let newRoute = {
      name: route.name,
      params: Object.assign({}, route.params || {}),
      query: Object.assign({}, route.query || {})
    }
    if (!asJson) {
      return newRoute
    } else {
      return JSON.stringify(newRoute)
    }
  },
  getRedirectRoute (route) {
    let prevRoute = url.getPrevRoute(route)
    if (prevRoute) {
      prevRoute = url.encode(prevRoute)
      return prevRoute
    } else {
      if (route.matched && route.matched[1]) {
        return Object.assign({}, {
          name: route.matched[1].name,
          params: route.matched[1].params,
          query: route.matched[1].query
        })
      } else {
        console.error('Redirect route not found')
      }
    }
    return null
  },
  getPrevOrCurrentRoute (route) {
    if (route?.query?.prevRoute) {
      return this.encode(route.query.prevRoute)
    }
    return this.getRoute(route)
  },
  getPrevRoute: function (route) {
    return route?.query?.prevRoute ?? null
  },
  encode: (url = '') => url ? JSON.parse(url) : ''
}

export default url
export {url}
